import { type FC } from 'react';

import { useIntl, defineMessages } from 'dibs-react-intl';
import MetaMask from 'dibs-icons/exports/legacy/MetaMask';
import WalletConnect from 'dibs-icons/exports/legacy/WalletConnect';
import classnames from 'classnames';

import styles from './styles/ConnectWalletButton.scss';

const messages = defineMessages({
    connectWalletCta: {
        id: 'connectMetamask.connectWalletCta',
        defaultMessage: 'Connect',
    },
});

type Props = {
    onOpenModal: () => void;
    isMobile?: boolean;
};

export const ConnectWalletButton: FC<Props> = ({ onOpenModal, isMobile }) => {
    const { formatMessage } = useIntl();
    return (
        <>
            {/* eslint-disable-next-line react/forbid-elements */}
            <button
                type="button"
                className={classnames(styles.connectButton, {
                    [styles.isMobileButton]: isMobile,
                })}
                onClick={onOpenModal}
                aria-label={formatMessage(messages.connectWalletCta)}
            >
                <MetaMask
                    className={classnames(styles.connectIcon, {
                        [styles.isMobileIcon]: isMobile,
                    })}
                />
                <WalletConnect
                    className={classnames(styles.connectIcon, {
                        [styles.isMobileIcon]: isMobile,
                    })}
                />
                {!isMobile && formatMessage(messages.connectWalletCta)}
            </button>
        </>
    );
};
